import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';
import Layout from "../components/Layout.vue";
import { useUserStore } from '../store/useUserStore';


// 페이지 컴포넌트들을 임포트합니다. 
import Dashboard from '../pages/Dashboard.vue';
import ReleaseList from '../pages/ReleaseList.vue';
import CreateRelease from '../pages/CreateRelease.vue';
import ChipsetList from '../pages/ChipsetList.vue';
import ModelList from '../pages/ModelList.vue';
import FirmwareTypeList from '../pages/FirmwareTypeList.vue';
import PackageTypeList from '../pages/PackageTypeList.vue';
import PackageList from '../pages/PackageList.vue';
import PriorityList from '../pages/PriorityList.vue';
import AppManagement from '../pages/AppManagement.vue';
import FirmwareManagement from '../pages/FirmwareManagement.vue';
import Settings from '../pages/Settings.vue';
import Login from '../pages/Login.vue';
import Logout from '../pages/Logout.vue';
import UserManagement from '../pages/UserManagement.vue';
import RoleManagement from '../pages/RoleManagement.vue';

const routes: RouteRecordRaw[] = [
  {
    path: "/",
    component: Layout,
    children: [
      //{ path: "", name: "dashboard", component: Dashboard }, // index: true 대신 빈 path 사용
      { path: "login", name: "login", component: Login },
      { path: "logout", name: "logout", component: Logout },
      { path: "releases", name: "releases", component: ReleaseList },
      { path: "releases/new", name: "release-create", component: CreateRelease },
      { path: "releases/update/:id", name: "release-edit", component: CreateRelease, props: true },
      { path: "chipsets", name: "chipsets", component: ChipsetList },
      { path: "models", name: "models", component: ModelList },
      { path: "firmware-types", name: "firmware-types", component: FirmwareTypeList },
      { path: "package-types", name: "package-types", component: PackageTypeList },
      { path: "packages", name: "packages", component: PackageList },
      { path: "priorities", name: "priorities", component: PriorityList },
      { path: "apps", name: "apps", component: AppManagement },
      { path: "firmwares", name: "firmwares", component: FirmwareManagement },
      { path: "settings", name: "settings", component: Settings },
      { path: "users", name: "users", component: UserManagement },
      { path: "roles", name: "roles", component: RoleManagement },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: routes,
})

// 사이드바 메뉴
const MENU_ORDER = [
  'releases', 'apps', 'firmwares',
  'chipsets', 'models', 'firmware-types', 'package-types', 'packages', 'priorities',
];

// 허용된 첫 번째 경로. 모두 막혔으면 /settings.
export const pickAllowedPath = (hidden: string[] = []): string => {
  const allowed = MENU_ORDER.find(m => hidden.includes(m));
  console.log("pickAllowedPath, hidden:", hidden, "allowed:", allowed);
  if (allowed) {
    return `/${allowed}`;
  }
  else {
    return '/settings';
  }
};

router.beforeEach((to, _from, next) => {
  const UserStore = useUserStore();
  const sessionValid = UserStore.checkSession();

  if (to.path === '/') {
    if (UserStore.isLoggedIn) {
      return next(pickAllowedPath(UserStore.menus ?? []));
    }
    return next('/login');
  }
  // 로그인 페이지(/login)는 항상 허용
  if (to.path === '/login') {
    if (UserStore.isLoggedIn) {
      return next(pickAllowedPath(UserStore.menus ?? []));
    }
    return next();
  }

  if (to.path === '/logout') {
    if (!UserStore.isLoggedIn) {
      return next('/');
    }
    return next();
  }

  if (!sessionValid) {
    alert('세션이 만료되었습니다. 다시 로그인해주세요.');
    return next('/logout');
  }

  // 로그인 안 된 사용자는 로그인 페이지로
  if (!UserStore.isLoggedIn) return next('/login');

  //users 는 Admin(role 1)만 접근 가능
  if (to.path.startsWith('/users') && UserStore.role !== 1) {
    return next(pickAllowedPath(UserStore.menus ?? []));
  }

  if (to.path.startsWith('/roles') && UserStore.role !== 1) {
    return next(pickAllowedPath(UserStore.menus ?? []));
  }

  const menuKey = to.path.split('/')[1];
  if (menuKey && !(UserStore.menus ?? []).includes(menuKey)) {
    return next(pickAllowedPath(UserStore.menus ?? []));
  }

  next();
});

export default router
